export default {
    ENTERPRISE: 'enterprise',
    ECOSYSTEM: 'ecosystem',
    STARTUP: 'startup',
}

export const licenseTypes = {
    'free': 'Free',
    'paid': 'Paid',
    'test': 'Test',
    'test_free': 'Test Free',
    'pilot': 'Pilot',
    'trial': 'Trial',
    'event_limited': 'Event Limited',
    'canceled': 'Canceled',
}

export const companyTypeEnterprise = 'enterprise';
export const companyTypeEcosystem = 'ecosystem';
export const companyTypeStartup = 'startup';
export const accountTypeStandard = 'standard';
export const accountTypePremium = 'premium';
export const accountTypePremiumTeaser = 'premiumTeaser';
export const accountTypeEventLimited = 'event_limited';
export const accountTypeFree = 'free';
export const accountTypeInvited = 'invited';

export const ecosystemTypes = {
    'incubator': 'Incubator',
    'accelerator': 'Accelerator',
    'university': 'University',
    'event': 'Event',
    'venture-capitalist': 'Venture Capitalist',
    'association': 'Association',
}
